import { Component, OnInit } from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent} from'src/app/layout/layout.component';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
interface SiteDto {
  siteCode: string;
  // 其他属性...
}
@Component({
  selector: 'app-MailServiceManagement',
  templateUrl: './wmsm-MailServiceManagement.component.html',
  styleUrls: ['./wmsm-MailServiceManagement.component.scss']
})
export class WmsmMailServiceManagementComponent extends BaseComponent implements OnInit {
  loading: boolean;

    // 表格每页显示条数,默认每頁顯示10筆資料
    pageSize: number =10;
    // 表格页码
    pageIndex: number = 1;
    nzTotal: number = 0;
    listOfData: any[] = [];
    fileList: NzUploadFile[] = [];
    isVisible:boolean = false
    dateFormat = 'yyyy/MM/dd';
    SiteList:any

  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  constructor(
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private AuthService: AuthService,
    private fb: FormBuilder,
    private http: HttpClient,
    private matomotracker:MatomoTracker,
    private LayoutComponent:LayoutComponent
  ) { super() }

  ngOnInit() {
    this.getResultData()
    this.validateForm = this.fb.group({
      mailtype:[''],
      mailtilleZHEN:[''],
      mailtextZHEN:[''],
      mailtilleVN:[''],
      mailtextVN:[''],
      Site:[[]],
      switch:['']
    });
    this.matomotracker.trackPageView("系統管理員權限設置")
    this.matomotracker.trackEvent("系統管理員權限設置","邮件服务管理","view",1);
    this.LayoutComponent.geturl()
    this.GetSite()
  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  getResultData(){
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetMailTemplateList.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data:{

      }
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.listOfData = res.data.sort((a, b) => a.mailType - b.mailType)
        this.nzTotal = res.total
      },
      (error) => {
       
      }
    );
  }


onOff(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateSendButton.url}`;
  const params = {    
    data:{
      mailType:data.mailType,
      type:"N",
  }};
  this.webApiService.doPost(url, params).subscribe(
    (res) => {
      if(res.status =="200"){
        this.getResultData()
      }

    },
    (error) => {
     
    }
  );
}

onopen(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateSendButton.url}`;
  const params = {
    data:{
      mailType:data.mailType,
      type:"Y",
    }
  };
  this.webApiService.doPost(url, params).subscribe(
    (res) => {
      if(res.status =="200"){
        this.getResultData()
      }
    },
    (error) => {
     
    }
  );
}

ActButton(data){
  this.isVisible=true
  if(data.exclSite!=null){
    var  data_list = data.exclSite.split(",")
  }else{
    var  data_list = null
  }

  this.validateForm.controls['mailtype'].setValue(data['mailType']);
      this.validateForm.controls['mailtilleZHEN'].setValue(data['subject']);
      this.validateForm.controls['mailtextZHEN'].setValue(data['mailMsg']);
      this.validateForm.controls['mailtilleVN'].setValue(data['vnSubject']);
      this.validateForm.controls['mailtextVN'].setValue(data['vnMailMsg']);
      this.validateForm.controls['Site'].setValue(data_list);
      this.validateForm.controls['mailtype'].disable();
}

Cancel(){
  this.isVisible=false
}

OnOk(){
  var site = []
  if(this.validateForm.controls['Site'].value==null){
    site = []
  }else{
    site  = this.validateForm.controls['Site'].value.filter(value => value !== '')
  }
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateMailTemplate.url}`;
  const params = {
    data:{
      MailType:this.validateForm.controls['mailtype'].value,
      Subject:this.validateForm.controls['mailtilleZHEN'].value,
      VnSubject:this.validateForm.controls['mailtilleVN'].value,
      MailMsg:this.validateForm.controls['mailtextZHEN'].value,
      VnMailMsg:this.validateForm.controls['mailtextVN'].value,
      //SendButton:this.validateForm.controls['mailtype'],
      ExclSite:site
    }
  };
  this.webApiService.doPost(url, params).subscribe(
    (res) => {
      if(res.status =="200"){
        this.getResultData()
        this.messageService.success('成功');
      }
     // this.validateForm.controls['Site'].setValue(this.SiteList[0].siteName);
    },
    (error) => {
    }
  );
  this.isVisible=false
}


GetSite() {
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteName.url}`;
  const params = {
  };
  this.webApiService.doPost(url, params).subscribe(
    (res) => {
      this.SiteList = res.sort(this.compare);
    },
    (error) => {
    }
  );
}

  //site排序
  compare(a: SiteDto, b: SiteDto): number {
    const nameA = a.siteCode.toUpperCase(); // 忽略大小写进行比较
    const nameB = b.siteCode.toUpperCase();
  
    if (nameA < nameB) {
      return -1;  // a 在 b 前面
    }
    if (nameA > nameB) {
      return 1;  // a 在 b 后面
    }
    return 0;  // 名称相同
  }

}
